import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import AdminGoogleDiagnostic from "@/pages/AdminGoogleDiagnostic";
import AdminUsers from "@/pages/AdminUsers";
import AdminSites from "@/pages/AdminSites";
import NewAnalysis from "@/pages/NewAnalysis";
import ImportAnalysis from "@/pages/ImportAnalysis";
import AnalysisDetail from "@/pages/AnalysisDetail";
import CausalDiagram from "@/pages/CausalDiagram";
import MeetingMode from "@/pages/MeetingMode";
import Aide from "@/pages/Aide";
import PolitiqueConfidentialite from "@/pages/PolitiqueConfidentialite";

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
      <Route
        path="/aide"
        element={
          <ProtectedRoute>
            <Aide />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/hfacs/nouveau"
        element={
          <ProtectedRoute roles={["Administrateur national", "Administrateur Site", "Utilisateur"]}>
            <NewAnalysis />
          </ProtectedRoute>
        }
      />
      <Route
        path="/hfacs/importer"
        element={
          <ProtectedRoute roles={["Administrateur national"]}>
            <ImportAnalysis />
          </ProtectedRoute>
        }
      />
      <Route
        path="/hfacs/:id"
        element={
          <ProtectedRoute>
            <AnalysisDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path="/hfacs/:id/diagramme"
        element={
          <ProtectedRoute>
            <CausalDiagram />
          </ProtectedRoute>
        }
      />
      <Route
        path="/hfacs/:id/reunion"
        element={
          <ProtectedRoute>
            <MeetingMode />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/utilisateurs"
        element={
          <ProtectedRoute roles={["Administrateur national", "Administrateur Site"]}>
            <AdminUsers />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/sites"
        element={
          <ProtectedRoute roles={["Administrateur national"]}>
            <AdminSites />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/google-diagnostic"
        element={
          <ProtectedRoute roles={["Administrateur national"]}>
            <AdminGoogleDiagnostic />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App font-body">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
      <Toaster />
    </div>
  );
}

export default App;
